webpackJsonp([1],{

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd9f018_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__(473);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd9f018_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationForm_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_222705e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationForm_vue__ = __webpack_require__(480);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_222705e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordForm_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f699979_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordForm_vue__ = __webpack_require__(482);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f699979_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveTimeModal_vue__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16014032_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveTimeModal_vue__ = __webpack_require__(536);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoveTimeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16014032_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoveTimeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTimeModal_vue__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a34498_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTimeModal_vue__ = __webpack_require__(538);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTimeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a34498_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTimeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_tooltip__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_notify__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_notify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_notify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate_dist_locale_nl__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_min_css__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_dist_theme_default_css__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_dist_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_material_dist_theme_default_css__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_material___default.a);

var Promise = __webpack_require__(583);

Promise.config({
    longStackTraces: true,
    warnings: true });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.ignoredElements = ['x-ticking-paragraph'];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue2_notify___default.a, {
    itemClass: '',
    permanent: false,
    duration: 300,
    visibility: 3000,

    position: 'bottom-right'
});

var types = {
    info: { itemClass: 'alert', iconClass: 'alert__icon mdi mdi-information' },
    error: { itemClass: 'alert--error', iconClass: 'alert__icon mdi mdi-alert-marked-circle' },
    warning: { itemClass: 'alert--warning', iconClass: 'alert__icon mdi mdi-alert' },
    success: { itemClass: 'alert--success', iconClass: 'alert__icon mdi mdi-checkbox-marked-circle' }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$notify.setTypes(types);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_v_tooltip__["a" /* default */]);

var veeConfig = {
    errorBagName: 'errors',
    fieldsBagName: 'fields',
    delay: 0
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate___default.a, veeConfig);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47dbe247_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(436);
function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47dbe247_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_TheFooter__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_TheHeader__ = __webpack_require__(59);






var _class;







var App = __WEBPACK_IMPORTED_MODULE_7_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(App, _Vue);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = App.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(App)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'app', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(App, [{
        key: 'created',
        value: function created() {
            console.log('Creating app');
            var config;
            if (true) {
                config = {
                    apiKey: "AIzaSyCmjb08qaPVvcDijpmNP83OB1Rfxvvcpgw",
                    authDomain: "mijn-markt-production.firebaseapp.com",
                    databaseURL: "https://mijn-markt-production.firebaseio.com",
                    projectId: "mijn-markt-production",
                    storageBucket: "mijn-markt-production.appspot.com",
                    messagingSenderId: "1092237197443"
                };
            } else {
                config = {
                    apiKey: "AIzaSyCRedIC-AQxtBzLrZ9qhDcfeKZkVYteCgk",
                    authDomain: "mijn-markt-68fbd.firebaseapp.com",
                    databaseURL: "https://mijn-markt-68fbd.firebaseio.com",
                    projectId: "mijn-markt-68fbd",
                    storageBucket: "mijn-markt-68fbd.appspot.com",
                    messagingSenderId: "861876961564"
                };
            }

            __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.initializeApp(config);
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);





var _class;




var TheFooter = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TheFooter, _Vue);

    function TheFooter() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TheFooter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TheFooter.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TheFooter)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'the-footer', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return TheFooter;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('the-footer', TheFooter);

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__text"},[_c('router-link',{staticClass:"button--link",attrs:{"to":{ name: 'privacy' }}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('router-link',{staticClass:"button--link",attrs:{"to":{ name: 'terms-of-service' }}},[_vm._v("Terms of Service")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);






var _dec, _class;






__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_v_media_query___default.a);

var TheHeader = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
    watch: {
        '$mq.resize': 'hideMobileMenu',

        showMobileMenu: function showMobileMenu(newVal) {
            var className = 'nav__mobile_open';
            if (newVal) {
                document.body.classList.add(className);
            } else {
                document.body.classList.remove(className);
            }
        }
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TheHeader, _Vue);

    function TheHeader() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TheHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TheHeader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TheHeader)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'the-header', _this.showMobileMenu = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TheHeader, [{
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {
            if (this.$mq.below(768)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'hideMobileMenu',
        value: function hideMobileMenu() {
            if (this.$mq.above(767)) {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'created',
        value: function created() {
            this.showMobileMenu = false;
        }
    }, {
        key: 'logout',
        value: function logout() {
            console.log('Sign our');
            __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signOut();
        }
    }]);

    return TheHeader;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('the-header', TheHeader);

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('span',{staticClass:"header__title"},[_vm._v("Mijn Markt")]),_vm._v(" "),void 0],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home_Home__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Styleguide__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_PageNotFound__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_AuthenticationPage__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_markets_MarketsPage__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_SettingsPage__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_market_MarketPage__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_vacancies_VacanciesPage__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_market_RecruitmentPage__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_PrivacyPolicy__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_TermsOfService__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_auth_forms_LoginForm__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_auth_forms_RegistrationForm__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_auth_forms_PasswordForm__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_general_menu_General__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_general_menu_Logo__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_general_menu_Market__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_firebase__);


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [{
        path: '/',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_2__pages_home_Home__["a" /* default */],
            menu: __WEBPACK_IMPORTED_MODULE_16__components_general_menu_General__["a" /* default */]
        },
        children: [{
            name: 'Home',
            path: '',
            redirect: 'vacancies'
        }, {
            name: 'vacancies',
            path: 'vacancies',
            components: {
                default: __WEBPACK_IMPORTED_MODULE_9__pages_vacancies_VacanciesPage__["a" /* default */],
                menu: __WEBPACK_IMPORTED_MODULE_17__components_general_menu_Logo__["a" /* default */]
            },
            meta: { auth: false }
        }]
    }, {
        path: '/page-not-found',
        name: 'PageNotFound',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_PageNotFound__["a" /* default */]
    }]
});

router.beforeEach(function (to, from, next) {

    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_188f88dd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-188f88dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_188f88dd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 440:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Home; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_TheHeader__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_TheFooter__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_Sidebar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_menu_Menu__ = __webpack_require__(444);






var _class;








var Home = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Home, _Vue);

    function Home() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Home);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Home.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Home)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'home-page', _this.menuVisible = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Home, [{
        key: 'toggleMenu',
        value: function toggleMenu() {
            this.menuVisible = !this.menuVisible;
        }
    }]);

    return Home;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('home-page', Home);

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);





var _dec, _class;




var Sidebar = (_dec = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()({
    data: function data() {
        return {
            showSidebar: false
        };
    },
    mounted: function mounted() {}
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Sidebar, _Vue);

    function Sidebar() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Sidebar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Sidebar.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'side-bar', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('side-bar', Sidebar);

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar",class:{active: _vm.showSidebar}},[_c('div',{staticClass:"sidebar__inner"},[_c('div',{staticClass:"sidebar__content"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"sidebar__logo"},[_c('a',{attrs:{"href":"/"}},[_vm._t("logo")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1fd2e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e1fd2e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1fd2e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuDrawer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_TheHeader__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_TheFooter__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_Sidebar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_media_query__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_firebase__);






var _dec, _class;










var MenuDrawer = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuDrawer, _Vue);

    function MenuDrawer() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuDrawer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = MenuDrawer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MenuDrawer)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'menu-drawer', _this.showMobileMenu = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MenuDrawer, [{
        key: 'logout',
        value: function logout() {}
    }, {
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {
            if (this.$mq.below(768)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }

            console.log('Toggle menu', this.showMobileMenu);
        }
    }]);

    return MenuDrawer;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('menu-drawer', MenuDrawer);

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('nav',{staticClass:"menu__content",class:{'is-open': _vm.showMobileMenu}},[_c('router-view',{attrs:{"name":"menu"}})],1),_vm._v(" "),_c('div',{staticClass:"menu__scrim"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app"},[_c('div',{staticClass:"wrapper",staticStyle:{"display":"flex","flex-direction":"row"},attrs:{"id":"app"}},[_c('menu-drawer'),_vm._v(" "),_c('main',{staticClass:"main",staticStyle:{"padding":"0"}},[_c('the-header'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',[_c('router-view')],1)])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Styleguide_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7bb6f26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Styleguide_vue__ = __webpack_require__(461);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Styleguide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7bb6f26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Styleguide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Styleguide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_StyleguideModal__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_StyleguideModalSmall__ = __webpack_require__(458);






var _class;






__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a);




var Styleguide = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Styleguide, _Vue);

    function Styleguide() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Styleguide);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Styleguide.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Styleguide)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'Styleguide', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Styleguide, [{
        key: 'showStyleguideModal',
        value: function showStyleguideModal() {
            this.$modal.show('styleguide-modal');
        }
    }, {
        key: 'showStyleguideModalSmall',
        value: function showStyleguideModalSmall() {
            this.$modal.show('styleguide-modal-small');
        }
    }]);

    return Styleguide;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(Styleguide.name, Styleguide);

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModal_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f10c00da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModal_vue__ = __webpack_require__(457);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f10c00da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleguideModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__ = __webpack_require__(61);





var _class;





var StyleguideModal = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StyleguideModal, _Vue);

    function StyleguideModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StyleguideModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StyleguideModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StyleguideModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'styleguide-modal', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return StyleguideModal;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(StyleguideModal.name, StyleguideModal);

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal__);






var _dec, _class;





__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default.a);

var ModalWrapper = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
    props: {
        modalName: String,
        modalClass: String
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalWrapper, _Vue);

    function ModalWrapper() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ModalWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ModalWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ModalWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'modal-wrapper', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ModalWrapper, [{
        key: 'beforeOpen',
        value: function beforeOpen(event) {
            document.getElementsByTagName('body')[0].className += ' modal__open';
            this.$emit('before-open', event);
        }
    }, {
        key: 'opened',
        value: function opened(event) {
            this.modalOpen = true;
            this.$emit('modalIsOpen', this.modalOpen);
        }
    }, {
        key: 'closed',
        value: function closed(event) {
            document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('modal__open', '');
            this.modalOpen = false;
            this.$emit('modalWasClosed', this.modalOpen);
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.$modal.hide(this.modalName);
        }
    }]);

    return ModalWrapper;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(ModalWrapper.name, ModalWrapper);

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{class:_vm.modalClass,attrs:{"name":_vm.modalName},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed}},[_c('a',{staticClass:"modal__close",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"mdi mdi-close"})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal","modalName":_vm.name}},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Styleguide modal")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Extra header")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is another dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"placeholder":"Choose an item..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is one more dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"placeholder":"Choose an item..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown to select multiple items")]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":['Multiple dropdown Item 1','Multiple dropdown Item 2','Multiple dropdown Item 3'],"placeholder":"Add item"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Another header")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('div',{staticClass:"form__label"},[_vm._v("Description text input")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Enter description (optional)..."}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Description textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea",attrs:{"placeholder":"Enter remarks (optional)..."}})])]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"}},[_vm._v("Add / Save")]),_vm._v(" "),_c('button',{staticClass:"button--alt",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModalSmall_vue__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022acbc7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModalSmall_vue__ = __webpack_require__(460);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModalSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022acbc7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModalSmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleguideModalSmall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__ = __webpack_require__(61);





var _class;





var StyleguideModalSmall = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StyleguideModalSmall, _Vue);

    function StyleguideModalSmall() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StyleguideModalSmall);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StyleguideModalSmall.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StyleguideModalSmall)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'styleguide-modal-small', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return StyleguideModalSmall;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(StyleguideModalSmall.name, StyleguideModalSmall);

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal--small","modalName":_vm.name}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Styleguide modal small")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_vm._v("\n        Modal for for example a confirmation or simple question.\n    ")]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"}},[_vm._v("Ok")]),_vm._v(" "),_c('button',{staticClass:"button--alt",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-8 col-md-6"},[_vm._m(4,false,false),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_vm._m(6,false,false),_vm._v(" "),_vm._m(7,false,false),_vm._v(" "),_vm._m(8,false,false),_vm._v(" "),_vm._m(9,false,false),_vm._v(" "),_vm._m(10,false,false),_vm._v(" "),_vm._m(11,false,false),_vm._v(" "),_vm._m(12,false,false),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a large dropdown")]),_vm._v(" "),_c('v-select',{staticClass:"dropdown--large",attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a multiple select dropdown")]),_vm._v(" "),_c('v-select',{staticClass:"dropdown",attrs:{"multiple":"","options":['First item','Second item','Third item'],"placeholder":"Choose an item..."}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{staticClass:"has-error",attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])],1)])]),_vm._v(" "),_vm._m(13,false,false)])])])])]),_vm._v(" "),_vm._m(14,false,false),_vm._v(" "),_vm._m(15,false,false),_vm._v(" "),_vm._m(16,false,false),_vm._v(" "),_vm._m(17,false,false),_vm._v(" "),_vm._m(18,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(19,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('button',{staticClass:"button--cta",on:{"click":_vm.showStyleguideModal}},[_vm._v("Open modal")]),_vm._v(" "),_c('button',{staticClass:"button--cta",on:{"click":_vm.showStyleguideModalSmall}},[_vm._v("Open small modal")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(20,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:('This tooltip is positioned at the top!'),expression:"'This tooltip is positioned at the top!'",modifiers:{"top":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Top tooltip - Hover over me!")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('This tooltip is positioned on the right!'),expression:"'This tooltip is positioned on the right!'",modifiers:{"right":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Right tooltip - Hover over me!")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:('This tooltip is positioned on the left!'),expression:"'This tooltip is positioned on the left!'",modifiers:{"left":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Left tooltip - Hover over me!")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('This tooltip is positioned at the bottom!'),expression:"'This tooltip is positioned at the bottom!'",modifiers:{"bottom":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Bottom tooltip - Hover over me!")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(21,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table"},[_vm._m(22,false,false),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 1")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_vm._m(23,false,false),_vm._v(" "),_vm._m(24,false,false),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is another table item")]),_vm._v(" "),_c('td',[_vm._v("Type 4")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_vm._m(25,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table--alt"},[_vm._m(26,false,false),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 1")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_vm._m(27,false,false),_vm._v(" "),_vm._m(28,false,false),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is another table item")]),_vm._v(" "),_c('td',[_vm._v("Type 4")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_vm._m(29,false,false)])])])])])])])]),_vm._v(" "),_c('styleguide-modal'),_vm._v(" "),_c('styleguide-modal-small')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Styleguide")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Buttons")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('a',{staticClass:"button--cta",attrs:{"href":"#"}},[_vm._v("Button CTA")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":"#"}},[_vm._v("Button")]),_vm._v(" "),_c('a',{staticClass:"button--alt",attrs:{"href":"#"}},[_vm._v("Button ALT")]),_vm._v(" "),_c('a',{staticClass:"button--cta is-disabled",attrs:{"href":"#","disabled":""}},[_vm._v("Button Disabled")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Search")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"styleguide__item"},[_c('form',{staticClass:"search"},[_c('input',{staticClass:"search__input",attrs:{"type":"search","placeholder":"Search.."}}),_vm._v(" "),_c('button',{staticClass:"search__button button--cta",attrs:{"type":"submit"}},[_vm._v("Search")])])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('form',{staticClass:"search"},[_c('input',{staticClass:"search__input",attrs:{"type":"search","placeholder":"Search.."}}),_vm._v(" "),_c('button',{staticClass:"search__button button",attrs:{"type":"submit"}},[_vm._v("Search")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Forms")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("These are your options:")]),_vm._v(" "),_c('div',{staticClass:"checkbox is-inline"},[_c('input',{staticClass:"checkbox__cb",attrs:{"type":"checkbox","id":"cb"}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":"cb"}},[_vm._v("Optie 1")])]),_vm._v(" "),_c('div',{staticClass:"checkbox is-inline"},[_c('input',{staticClass:"checkbox__cb",attrs:{"type":"checkbox","id":"cb_2"}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":"cb_2"}},[_vm._v("Optie 2")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Choose an option:")]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio"}},[_vm._v("Radio button 1")])]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio_1"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio_1"}},[_vm._v("Radio button 2")])]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio_2"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio_2"}},[_vm._v("Radio button 3")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Text field 1")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"This is an input field"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea",attrs:{"placeholder":"Start typing here..."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea has-error",attrs:{"placeholder":"Start typing here..."}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Disabled text field")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"This is an disabled input field","disabled":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Text field with an error")]),_vm._v(" "),_c('input',{staticClass:"form__input--text has-error",attrs:{"type":"text","placeholder":"Dit is an input field with an error","value":"test"}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a select")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',[_c('option',[_vm._v("Choose...")]),_vm._v(" "),_c('option',[_vm._v("Option 1")]),_vm._v(" "),_c('option',[_vm._v("Option 2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is an error select")]),_vm._v(" "),_c('div',{staticClass:"select has-error"},[_c('select',[_c('option',[_vm._v("Choose...")]),_vm._v(" "),_c('option',[_vm._v("Option 1")]),_vm._v(" "),_c('option',[_vm._v("Option 2")])])]),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"form__button button--cta",attrs:{"type":"submit","href":"#"}},[_vm._v("Button")]),_vm._v(" "),_c('a',{staticClass:"form__button button--alt",attrs:{"href":"#"}},[_vm._v("Cancel")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Alerts")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6"},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert"},[_vm._v("This is a normal information alert!")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--success"},[_vm._v("This is a success alert!")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--warning"},[_vm._v("This is a warning alert")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--error"},[_vm._v("This is an error alert")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Teksten")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('h1',[_vm._v("This is an H1 text")]),_vm._v(" "),_c('h2',[_vm._v("This is an H2 text")]),_vm._v(" "),_c('h3',[_vm._v("This is an H3 text")]),_vm._v(" "),_c('h4',[_vm._v("This is an H4 text")]),_vm._v(" "),_c('h5',[_vm._v("This is an H5 text")]),_vm._v(" "),_c('h6',[_vm._v("This is an H6 text")]),_vm._v(" "),_c('p',[_vm._v("This is a short text to present what some standard, "),_c('strong',[_vm._v("bold")]),_vm._v(" and "),_c('i',[_vm._v("italic")]),_vm._v(" text and "),_c('a',{attrs:{"href":"#"}},[_vm._v("a link")]),_vm._v(" would look like.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Breadcrumb")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('ul',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Home")]),_c('i',{staticClass:"breadcrumb__icon mdi mdi-chevron-right"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Category")]),_c('i',{staticClass:"breadcrumb__icon mdi mdi-chevron-right"})]),_vm._v(" "),_c('li',[_vm._v("Security Design Tool")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Pagination")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#"}},[_vm._v("1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("3")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Spinner")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"spinner"})]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"spinner--small"})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Modal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Tooltips")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"table__wrap"},[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"},[_vm._v("Remarks")]),_vm._v(" "),_c('th',{staticClass:"table__cell--date"},[_vm._v("Last edit")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"}),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v(" Subitem 1")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v(" Subitem 2")]),_vm._v(" "),_c('td',[_vm._v("Type 3")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v(" Subitem 3")]),_vm._v(" "),_c('td',[_vm._v("Type 5")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"table__wrap"},[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"},[_vm._v("Remarks")]),_vm._v(" "),_c('th',{staticClass:"table__cell--date"},[_vm._v("Last edit")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"}),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v(" Subitem 1")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v(" Subitem 2")]),_vm._v(" "),_c('td',[_vm._v("Type 3")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v(" Subitem 3")]),_vm._v(" "),_c('td',[_vm._v("Type 5")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b657e26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(464);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b657e26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);





var _class;




var PageNotFound = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PageNotFound, _Vue);

    function PageNotFound() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PageNotFound);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PageNotFound.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PageNotFound)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'page-not-found', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return PageNotFound;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(PageNotFound.name, PageNotFound);

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('h2',[_vm._v("Sorry, deze pagina bestaat niet...")]),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'Home' }}},[_vm._v("Ga terug")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticationPage_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d814836_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticationPage_vue__ = __webpack_require__(484);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d814836_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_Authentication__ = __webpack_require__(467);





var _class;





var AuthenticationPage = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AuthenticationPage, _Vue);

    function AuthenticationPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthenticationPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AuthenticationPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AuthenticationPage)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'authentication-page', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return AuthenticationPage;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(AuthenticationPage.name, AuthenticationPage);

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentication_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cbe7d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentication_vue__ = __webpack_require__(483);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cbe7d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Authentication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_LoginForm__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms_RegistrationForm__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_PasswordForm__ = __webpack_require__(179);






var _class;









var Authentication = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Authentication, _Vue);

    function Authentication() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Authentication);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Authentication.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Authentication)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'authentication', _this.authComponent = __WEBPACK_IMPORTED_MODULE_8__forms_LoginForm__["a" /* default */], _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Authentication, [{
        key: 'created',
        value: function created() {
            var user = __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().currentUser;
            if (user) {
                this.$router.go('/');
            }
        }
    }, {
        key: 'switchAuthComponent',
        value: function switchAuthComponent(value) {
            this.authComponent = value;
        }
    }]);

    return Authentication;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(Authentication.name, Authentication);

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_alerts_Alert__ = __webpack_require__(470);






var _class;






var LoginForm = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LoginForm, _Vue);

    function LoginForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LoginForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = LoginForm.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'login-form', _this.email = '', _this.password = '', _this.error = '', _this.loading = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LoginForm, [{
        key: 'created',
        value: function created() {}
    }, {
        key: 'login',
        value: function login() {
            var _this2 = this;

            this.error = '';
            this.loading = true;

            console.log('Login', 'New login try', this.email, this.password);
            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function () {
                _this2.loading = false;


                var redirect = _this2.$route.query.redirect;
                if (redirect) {
                    _this2.$router.replace(redirect);
                } else {
                    _this2.$router.replace({
                        name: 'markets'
                    });
                }
            }).catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;

                _this2.loading = false;

                switch (errorCode) {
                    case 'auth/invalid-email':
                        _this2.error = 'Dit e-mailadres is ongeldig.';
                        break;
                    case 'auth/user-disabled':
                        _this2.error = 'Sorry, je account is geblokkeerd door de administrator.';
                        break;
                    case 'auth/user-not-found':
                        _this2.error = 'Er bestaat geen gebruiker met did e-mailadres.';
                        break;
                    case 'auth/wrong-password':
                        _this2.error = 'De gegevens kwamen niet overeen.';
                        break;
                    case 'auth/network-request-failed':
                        _this2.$notify('Kon geen verbinding maken met het internet.');
                        break;
                }

                console.error('Login error', errorCode, errorMessage);
            });
        }
    }, {
        key: 'google',
        value: function google() {
            var _this3 = this;

            this.loading = true;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().useDeviceLanguage();
            var provider = new __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth.GoogleAuthProvider();
            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
                var token = result.credential.accessToken;

                var user = result.user;

                _this3.loading = false;
                console.log('Signed In', user);


                var redirect = _this3.$route.query.redirect;
                if (redirect) {
                    _this3.$router.replace(redirect);
                } else {
                    _this3.$router.replace({
                        name: 'markets'
                    });
                }
            }).catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;

                var email = error.email;

                var credential = error.credential;


                _this3.loading = false;
                console.log('Sign in error', errorCode, errorMessage, email);
            });
        }
    }, {
        key: 'facebook',
        value: function facebook() {
            var _this4 = this;

            this.loading = true;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().useDeviceLanguage();
            var provider = new __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth.FacebookAuthProvider();
            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
                var token = result.credential.accessToken;

                var user = result.user;

                _this4.loading = false;
                console.log('Signed In', user);


                var redirect = _this4.$route.query.redirect;
                if (redirect) {
                    _this4.$router.replace(redirect);
                } else {
                    _this4.$router.replace({
                        name: 'markets'
                    });
                }
            }).catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;

                var email = error.email;

                var credential = error.credential;


                _this4.loading = false;
                console.log('Sign in error', errorCode, errorMessage, email);
            });
        }
    }]);

    return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(LoginForm.name, LoginForm);

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43af3451_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(472);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43af3451_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);





var _dec, _class;




var Alert = (_dec = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()({
    props: {
        text: {
            type: String,
            default: 'A generic alert'
        },
        close: {
            type: Boolean,
            default: true
        }
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Alert, _Vue);

    function Alert() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Alert);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Alert.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Alert)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'alert', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return Alert;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(Alert.name, Alert);

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('span',{staticClass:"mdi-close"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('form',{staticClass:"form"},[_c('h3',[_vm._v("Inloggen met e-mail en wachtwoord")]),_vm._v(" "),(_vm.error !== undefined && _vm.error.length > 0)?_c('div',{staticClass:"alert--error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form__input--text",attrs:{"type":"email","name":"Email","autocomplete":"email","placeholder":"E-mailadres","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form__input--text",attrs:{"type":"password","autocomplete":"password","name":"Wachtwoord","placeholder":"Wachtwoord","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",on:{"click":function($event){$event.preventDefault();_vm.login($event)}}},[_vm._v("Inloggen")])])]),_vm._v(" "),_c('div',{staticClass:"link_block"},[_c('router-link',{attrs:{"to":"register"}},[_c('strong',[_vm._v("Nog geen account?")])]),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"password/forgotten"}},[_vm._v("Wachtwoord vergeten?")])],1),_vm._v(" "),_c('div',{staticClass:"link_block"},[_c('button',{staticClass:"button--cta",on:{"click":function($event){$event.preventDefault();_vm.google($event)}}},[_vm._v("Google")]),_vm._v(" "),_c('button',{staticClass:"button--cta",on:{"click":function($event){$event.preventDefault();_vm.facebook($event)}}},[_vm._v("Facebook")])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegistrationForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase__);







var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}





var RegistrationForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('email'), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('emailRepeat'), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('password'), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('passwordRepeat'), __WEBPACK_IMPORTED_MODULE_7_vue_class_component___default()(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RegistrationForm, _Vue);

    function RegistrationForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RegistrationForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = RegistrationForm.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(RegistrationForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'registration-form', _this.registrationComplete = false, _this.error = '', _this.email = '', _this.emailRepeat = '', _this.emailError = '', _this.emailErrorFlag = false, _this.password = '', _this.passwordRepeat = '', _this.passwordError = '', _this.passwordErrorFlag = false, _this.nameErrorFlag = false, _this.userName = '', _this.phone = '', _this.loading = false, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RegistrationForm, [{
        key: 'changeAuthView',
        value: function changeAuthView(value, event) {
            this.$emit('changeAuthComponent', value);
        }
    }, {
        key: 'register',
        value: function register() {
            var _this2 = this;

            this.loading = true;
            console.log(__WEBPACK_IMPORTED_MODULE_9_firebase___default.a.auth().currentUser);
            if (!this.hasEmailError() && !this.hasPasswordError() && this.email !== undefined && this.password !== undefined && this.email.length > 0 && this.password.length > 0) {
                __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (test) {
                    console.log(fireabse.auth().currentUser);
                    console.log('SUCCESS', test);

                    user.updateProfile({
                        displayName: _this2.userName
                    }).then(function () {

                        this.loading = false;
                    }).catch(function (error) {
                        this.loading = false;
                    });
                }).catch(function (error) {
                    var errorCode = error.code;
                    var message = error.message;

                    console.error('Sign up error', errorCode, message);

                    switch (errorCode) {
                        case 'auth/invalid-email':
                            _this2.showError('Your e-mail address is invalid.');
                            break;
                        case 'auth/email-already-in-use':
                            _this2.showError('This e-mail address is already in use.');
                            break;
                        case 'auth/weak-password':
                            _this2.showError('Your password is not strong enough. A strong password is at least 6 characters in length and preferably contains both upper- and lowercase letters and numbers.');
                            break;
                        default:
                            _this2.showError('Something went wrong.');
                            break;
                    }
                });
            } else {
                this.showError('Please fill in all required fields and correct any mistakes.');

                this.emailErrorFlag = this.email.length > 0 && this.emailError.length === 0;

                this.passwordErrorFlag = this.password.length > 0 && this.passwordError.length === 0;

                this.nameErrorFlag = this.userName === undefined || this.userName.length === 0;

                this.loading = false;
            }
        }
    }, {
        key: 'emailWatcher',
        value: function emailWatcher() {
            var email = this.email;
            var repeat = this.emailRepeat;
            if (email !== undefined && repeat !== undefined && email.length > 0 && repeat.length > 0) {
                if (email !== repeat) {
                    this.emailError = 'Your e-mail addresses do not match.';
                    this.emailErrorFlag = true;
                } else {
                    this.emailError = '';
                    this.emailErrorFlag = true;
                }
            }
        }
    }, {
        key: 'hasEmailError',
        value: function hasEmailError() {
            return this.emailError !== undefined && this.emailError.length > 0 || this.emailErrorFlag;
        }
    }, {
        key: 'passwordWatcher',
        value: function passwordWatcher() {
            var password = this.password;
            var repeat = this.passwordRepeat;
            if (password !== undefined && repeat !== undefined && password.length > 0 && repeat.length > 0) {
                if (password !== repeat) {
                    this.passwordError = 'Your passwords do not match.';
                    this.passwordErrorFlag = true;
                } else {
                    this.passwordError = '';
                    this.passwordErrorFlag = false;
                }
            }
        }
    }, {
        key: 'hasPasswordError',
        value: function hasPasswordError() {
            return this.passwordError !== undefined && this.passwordError.length > 0 || this.passwordErrorFlag;
        }
    }, {
        key: 'showError',
        value: function showError(message) {
            this.error = message;
            scrollTo(document, 0, 2000);
        }
    }]);

    return RegistrationForm;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'emailWatcher', [_dec, _dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'emailWatcher'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'passwordWatcher', [_dec3, _dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'passwordWatcher'), _class2.prototype)), _class2)) || _class);



__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component(RegistrationForm.name, RegistrationForm);

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scrollTo */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDaysLong;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDayLong;
function scrollTo(element, to, duration) {
    if (duration < 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 2;

    setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick;
        scrollTo(element, to, duration - 2);
    }, 10);
}

function getDaysLong() {
    var days = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag'];

    return days;
}

function getDayLong(day) {
    var days = {
        1: 'Maandag',
        2: 'Dinsdag',
        3: 'Woensdag',
        4: 'Donderdag',
        5: 'Vrijdag',
        6: 'Zaterdag',
        7: 'Zondag'
    };

    return days[day];
}

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',[(_vm.registrationComplete)?_c('div',[_c('h3',[_vm._v("Account succesvol aangemaakt")]),_vm._v(" "),_c('p',[_vm._v("Er is een e-mail verstuurd naar e-mailadres. In die e-mail staat hoe u uw registratie kunt afronden.")]),_vm._v(" "),_c('a',{staticClass:"button--cta",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.changeAuthView('LoginForm')}}},[_vm._v("Terug naar inlogscherm")])]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"form"},[_c('h3',[_vm._v("Maak account aan ")]),_vm._v(" "),(_vm.error !== undefined && _vm.error.length > 0)?_c('div',{staticClass:"alert--error"},[_vm._v(_vm._s(_vm.error))]):_c('p',{staticClass:"is-muted"},[_vm._v("* Verplichte velden")]),_vm._v(" "),_c('h4',[_vm._v("Accountgegevens")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form__input--text",class:{ 'has-error': _vm.emailErrorFlag },attrs:{"type":"text","autocomplete":"email","required":"","placeholder":"E-mailadres *"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailRepeat),expression:"emailRepeat"}],staticClass:"form__input--text",class:{ 'has-error': _vm.emailErrorFlag },attrs:{"type":"text","autocomplete":"email","required":"","placeholder":"Herhaal e-mailadres *"},domProps:{"value":(_vm.emailRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailRepeat=$event.target.value}}}),_vm._v(" "),(_vm.hasEmailError())?_c('span',{staticClass:"form__error_text"},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form__input--text",class:{ 'has-error': _vm.passwordErrorFlag },attrs:{"type":"password","autocomplete":"new-password","required":"","placeholder":"Wachtwoord *"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordRepeat),expression:"passwordRepeat"}],staticClass:"form__input--text",class:{ 'has-error': _vm.passwordErrorFlag },attrs:{"type":"password","autocomplete":"new-password","required":"","placeholder":"Herhaal wachtwoord *"},domProps:{"value":(_vm.passwordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordRepeat=$event.target.value}}}),_vm._v(" "),(_vm.hasPasswordError())?_c('span',{staticClass:"form__error_text"},[_vm._v(_vm._s(_vm.passwordError))]):_vm._e()]),_vm._v(" "),_c('h4',[_vm._v("Persoonlijke gegevens")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"form__input--text",class:{ 'has-error': _vm.nameErrorFlag },attrs:{"type":"text","placeholder":"Voor- en Achternaam *","required":"","autocomplete":"name"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Telefoonnummer","autocomplete":"tel"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__buttons align-content-end"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.register($event)}}},[_vm._v("Maak account aan")]),_vm._v(" "),_c('router-link',{staticClass:"button--link",attrs:{"to":"signin"}},[_vm._v("Annuleren")])],1)])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(48);






var _class;






var PasswordForm = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PasswordForm, _Vue);

    function PasswordForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PasswordForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PasswordForm.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'password-form', _this.newPasswordSent = false, _this.email = '', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PasswordForm, [{
        key: 'changeAuthView',
        value: function changeAuthView(value, event) {
            this.$emit('changeAuthComponent', value);
        }
    }, {
        key: 'sendPasswordReset',
        value: function sendPasswordReset() {
            var _this2 = this;

            if (this.email !== undefined && this.email.length > 0) {
                __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().sendPasswordResetEmail(this.email).then(function () {
                    _this2.newPasswordSent = true;
                }).catch(function (error) {
                    console.log('Reset', error.code, error.message);
                });
            }
        }
    }]);

    return PasswordForm;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(PasswordForm.name, PasswordForm);

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.newPasswordSent)?_c('div',[_c('h2',[_vm._v("Nieuw wachtwoord verzonden")]),_vm._v(" "),_c('p',[_vm._v("Als er een account bij ons bekend is is er een e-mail verstuurd naar "),_c('strong',[_vm._v(_vm._s(_vm.email))]),_vm._v(" met een link om uw wachtwoord aan te passen.")]),_vm._v(" "),_c('a',{staticClass:"button--cta",attrs:{"href":"/auth"},on:{"click":function($event){$event.preventDefault();_vm.changeAuthView('LoginForm')}}},[_vm._v("Terug naar inlogscherm")])]):_c('form',{staticClass:"form"},[_c('h3',[_vm._v("Wachtwoord vergeten?")]),_vm._v(" "),_c('p',[_vm._v("Vul hieronder uw e-mailadres in en u ontvangt een e-mail met uw nieuwe wachtwoord.")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form__input--text",attrs:{"type":"email","name":"Email","placeholder":"E-mailadres"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.sendPasswordReset($event)}}},[_vm._v("Stuur nieuw wachtwoord")]),_vm._v(" "),_c('router-link',{staticClass:"button--link",attrs:{"to":{ name: 'signin' }}},[_vm._v("Annuleren")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authentication')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketsPage_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec1adb92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketsPage_vue__ = __webpack_require__(528);
function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec1adb92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec1adb92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarketsPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);






var _class;






__webpack_require__(81);

var MarketsPage = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MarketsPage, _Vue);

    function MarketsPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MarketsPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = MarketsPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MarketsPage)).call.apply(_ref, [this].concat(args))), _this), _this.loading = true, _this.empty = false, _this.accepted = [], _this.pending = [], _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MarketsPage, [{
        key: 'mounted',
        value: function mounted() {}
    }, {
        key: 'fetch',
        value: function fetch(uid) {}
    }, {
        key: 'selected',
        value: function selected(market) {
            console.log('Markets', 'Selected market: ', market);
            this.$router.push({ name: 'market-dashboard', params: { key: market.key } });
        }
    }, {
        key: 'formatDate',
        value: function formatDate(stamp) {
            return __WEBPACK_IMPORTED_MODULE_8_moment___default()(stamp).format('DD MMMM YYYY');
        }
    }]);

    return MarketsPage;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('page-not-found', MarketsPage);

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 180,
	"./af.js": 180,
	"./ar": 181,
	"./ar-dz": 182,
	"./ar-dz.js": 182,
	"./ar-kw": 183,
	"./ar-kw.js": 183,
	"./ar-ly": 184,
	"./ar-ly.js": 184,
	"./ar-ma": 185,
	"./ar-ma.js": 185,
	"./ar-sa": 186,
	"./ar-sa.js": 186,
	"./ar-tn": 187,
	"./ar-tn.js": 187,
	"./ar.js": 181,
	"./az": 188,
	"./az.js": 188,
	"./be": 189,
	"./be.js": 189,
	"./bg": 190,
	"./bg.js": 190,
	"./bm": 191,
	"./bm.js": 191,
	"./bn": 192,
	"./bn.js": 192,
	"./bo": 193,
	"./bo.js": 193,
	"./br": 194,
	"./br.js": 194,
	"./bs": 195,
	"./bs.js": 195,
	"./ca": 196,
	"./ca.js": 196,
	"./cs": 197,
	"./cs.js": 197,
	"./cv": 198,
	"./cv.js": 198,
	"./cy": 199,
	"./cy.js": 199,
	"./da": 200,
	"./da.js": 200,
	"./de": 201,
	"./de-at": 202,
	"./de-at.js": 202,
	"./de-ch": 203,
	"./de-ch.js": 203,
	"./de.js": 201,
	"./dv": 204,
	"./dv.js": 204,
	"./el": 205,
	"./el.js": 205,
	"./en-au": 206,
	"./en-au.js": 206,
	"./en-ca": 207,
	"./en-ca.js": 207,
	"./en-gb": 208,
	"./en-gb.js": 208,
	"./en-ie": 209,
	"./en-ie.js": 209,
	"./en-nz": 210,
	"./en-nz.js": 210,
	"./eo": 211,
	"./eo.js": 211,
	"./es": 212,
	"./es-do": 213,
	"./es-do.js": 213,
	"./es-us": 214,
	"./es-us.js": 214,
	"./es.js": 212,
	"./et": 215,
	"./et.js": 215,
	"./eu": 216,
	"./eu.js": 216,
	"./fa": 217,
	"./fa.js": 217,
	"./fi": 218,
	"./fi.js": 218,
	"./fo": 219,
	"./fo.js": 219,
	"./fr": 220,
	"./fr-ca": 221,
	"./fr-ca.js": 221,
	"./fr-ch": 222,
	"./fr-ch.js": 222,
	"./fr.js": 220,
	"./fy": 223,
	"./fy.js": 223,
	"./gd": 224,
	"./gd.js": 224,
	"./gl": 225,
	"./gl.js": 225,
	"./gom-latn": 226,
	"./gom-latn.js": 226,
	"./gu": 227,
	"./gu.js": 227,
	"./he": 228,
	"./he.js": 228,
	"./hi": 229,
	"./hi.js": 229,
	"./hr": 230,
	"./hr.js": 230,
	"./hu": 231,
	"./hu.js": 231,
	"./hy-am": 232,
	"./hy-am.js": 232,
	"./id": 233,
	"./id.js": 233,
	"./is": 234,
	"./is.js": 234,
	"./it": 235,
	"./it.js": 235,
	"./ja": 236,
	"./ja.js": 236,
	"./jv": 237,
	"./jv.js": 237,
	"./ka": 238,
	"./ka.js": 238,
	"./kk": 239,
	"./kk.js": 239,
	"./km": 240,
	"./km.js": 240,
	"./kn": 241,
	"./kn.js": 241,
	"./ko": 242,
	"./ko.js": 242,
	"./ky": 243,
	"./ky.js": 243,
	"./lb": 244,
	"./lb.js": 244,
	"./lo": 245,
	"./lo.js": 245,
	"./lt": 246,
	"./lt.js": 246,
	"./lv": 247,
	"./lv.js": 247,
	"./me": 248,
	"./me.js": 248,
	"./mi": 249,
	"./mi.js": 249,
	"./mk": 250,
	"./mk.js": 250,
	"./ml": 251,
	"./ml.js": 251,
	"./mr": 252,
	"./mr.js": 252,
	"./ms": 253,
	"./ms-my": 254,
	"./ms-my.js": 254,
	"./ms.js": 253,
	"./mt": 255,
	"./mt.js": 255,
	"./my": 256,
	"./my.js": 256,
	"./nb": 257,
	"./nb.js": 257,
	"./ne": 258,
	"./ne.js": 258,
	"./nl": 259,
	"./nl-be": 260,
	"./nl-be.js": 260,
	"./nl.js": 259,
	"./nn": 261,
	"./nn.js": 261,
	"./pa-in": 262,
	"./pa-in.js": 262,
	"./pl": 263,
	"./pl.js": 263,
	"./pt": 264,
	"./pt-br": 265,
	"./pt-br.js": 265,
	"./pt.js": 264,
	"./ro": 266,
	"./ro.js": 266,
	"./ru": 267,
	"./ru.js": 267,
	"./sd": 268,
	"./sd.js": 268,
	"./se": 269,
	"./se.js": 269,
	"./si": 270,
	"./si.js": 270,
	"./sk": 271,
	"./sk.js": 271,
	"./sl": 272,
	"./sl.js": 272,
	"./sq": 273,
	"./sq.js": 273,
	"./sr": 274,
	"./sr-cyrl": 275,
	"./sr-cyrl.js": 275,
	"./sr.js": 274,
	"./ss": 276,
	"./ss.js": 276,
	"./sv": 277,
	"./sv.js": 277,
	"./sw": 278,
	"./sw.js": 278,
	"./ta": 279,
	"./ta.js": 279,
	"./te": 280,
	"./te.js": 280,
	"./tet": 281,
	"./tet.js": 281,
	"./th": 282,
	"./th.js": 282,
	"./tl-ph": 283,
	"./tl-ph.js": 283,
	"./tlh": 284,
	"./tlh.js": 284,
	"./tr": 285,
	"./tr.js": 285,
	"./tzl": 286,
	"./tzl.js": 286,
	"./tzm": 287,
	"./tzm-latn": 288,
	"./tzm-latn.js": 288,
	"./tzm.js": 287,
	"./uk": 289,
	"./uk.js": 289,
	"./ur": 290,
	"./ur.js": 290,
	"./uz": 291,
	"./uz-latn": 292,
	"./uz-latn.js": 292,
	"./uz.js": 291,
	"./vi": 293,
	"./vi.js": 293,
	"./x-pseudo": 294,
	"./x-pseudo.js": 294,
	"./yo": 295,
	"./yo.js": 295,
	"./zh-cn": 296,
	"./zh-cn.js": 296,
	"./zh-hk": 297,
	"./zh-hk.js": 297,
	"./zh-tw": 298,
	"./zh-tw.js": 298
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.pending),function(market){return _c('tr',{on:{"click":function($event){$event.preventDefault();_vm.selected(market)}}},[_c('td',[_vm._v("\n                    "+_vm._s(market.name)+"\n                ")]),_vm._v(" "),_c('td',[(market.pending)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Wachtend op je reactie...'),expression:"'Wachtend op je reactie...'",modifiers:{"right":true}}],staticClass:"mdi mdi-settings"}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                    Accepteren\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                    Afwijzen\n                ")])])}))])]),_vm._v(" "),_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table"},[_c('tbody',[_vm._l((_vm.pending),function(market){return _c('tr',{on:{"click":function($event){$event.preventDefault();_vm.selected(market)}}},[_c('td',[_vm._v("\n                    "+_vm._s(market.name)+"\n                ")]),_vm._v(" "),_c('td',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:('Geaccepteerd'),expression:"'Geaccepteerd'",modifiers:{"left":true}}],staticClass:"mdi mdi-check"})]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.formatDate(market.accepted))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"delete"},[_vm._v("\n                    Verwijderen\n                ")])])}),_vm._v(" "),_vm._l((_vm.accepted),function(market){return _c('tr',{on:{"click":function($event){$event.preventDefault();_vm.selected(market)}}},[_c('td',[_vm._v("\n                    "+_vm._s(market.name)+"\n                ")]),_vm._v(" "),_c('td',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:('Geaccepteerd'),expression:"'Geaccepteerd'",modifiers:{"left":true}}],staticClass:"mdi mdi-check"})]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.formatDate(market.accepted))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"delete"},[_vm._v("\n                    Verwijderen\n                ")])])})],2)])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsPage_vue__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67026297_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsPage_vue__ = __webpack_require__(531);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67026297_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);





var _class;




var SettingsPage = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SettingsPage, _Vue);

  function SettingsPage() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SettingsPage);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SettingsPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SettingsPage)).apply(this, arguments));
  }

  return SettingsPage;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('settings-page', SettingsPage);

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('h2',[_vm._v("Sorry, deze pagina bestaat niet...")]),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'Home' }}},[_vm._v("Ga terug")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketPage_vue__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc82cc2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketPage_vue__ = __webpack_require__(539);
function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fc82cc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc82cc2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 533:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarketPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modals_RemoveTimeModal_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modals_AddTimeModal_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(48);






var _class;








__webpack_require__(81);

var MarketPage = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MarketPage, _Vue);

    function MarketPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MarketPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = MarketPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MarketPage)).call.apply(_ref, [this].concat(args))), _this), _this.market = {}, _this.loading = true, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MarketPage, [{
        key: 'mounted',
        value: function mounted() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().onAuthStateChanged(function (user) {
                if (user) {
                    _this2.fetchMarket();
                } else {
                    console.log(App.name, 'User is signed out');
                    _this2.$router.push('/auth');
                }
            });
        }
    }, {
        key: 'fetchMarket',
        value: function fetchMarket() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore().collection('markets').doc(this.$route.params.key).get().then(function (snap) {
                console.log('Stand!', snap.data());

                _this3.loading = false;
                _this3.market = snap.data();
            }).catch(function (error) {
                console.error('Error', error);
                _this3.loading = false;
            });
        }
    }, {
        key: 'getDay',
        value: function getDay(day) {
            return Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* getDayLong */])(day);
        }
    }, {
        key: 'getDays',
        value: function getDays() {
            return Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getDaysLong */])();
        }
    }, {
        key: 'createOpeningTime',
        value: function createOpeningTime(time) {
            var _this4 = this;

            var times = this.market.openingTimes;
            if (!times) {
                times = {};
            }
            console.log('CREATE', time, times);

            times[time.day] = time;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore().collection('markets').doc(this.market.key).update({
                openingTimes: times
            }).then(function () {
                _this4.$modal.hide('add-time-modal');
                _this4.$notify('Nieuwe openingstijd is toegevoegd', 'success');

                _this4.fetchMarket();
            }).catch();
        }
    }, {
        key: 'editTime',
        value: function editTime(time) {
            this.$modal.show('add-time-modal', { time: time });
        }
    }, {
        key: 'confirmRemoveTime',
        value: function confirmRemoveTime(time) {
            this.$modal.show('remove-time-modal', { time: time });
        }
    }, {
        key: 'removeTime',
        value: function removeTime(time) {
            var _this5 = this;

            var times = this.market.openingTimes;
            if (!times) {
                times = {};
            }

            delete times[time.day];

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore().collection('markets').doc(this.market.key).update({
                openingTimes: times
            }).then(function () {
                _this5.$modal.hide('remove-time-modal');
                _this5.$notify('Openingstijd voor ' + _this5.getDays()[time.day - 1] + ' verwijderd', 'success');

                _this5.fetchMarket();
            }).catch();
        }
    }]);

    return MarketPage;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('market-page', MarketPage);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveTimeModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_ModalWrapper__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(48);






var _class;







var RemoveTimeModal = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RemoveTimeModal, _Vue);

    function RemoveTimeModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RemoveTimeModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = RemoveTimeModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RemoveTimeModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'remove-time-modal', _this.time = {}, _this.loading = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RemoveTimeModal, [{
        key: 'confirm',
        value: function confirm() {
            this.loading = true;
            this.$emit('confirm', this.time);
        }
    }, {
        key: 'beforeOpen',
        value: function beforeOpen(event) {
            this.loading = false;
            this.time = event.params.time;
        }
    }, {
        key: 'getDay',
        value: function getDay(day) {
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* getDayLong */])(day);
        }
    }]);

    return RemoveTimeModal;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(RemoveTimeModal.name, RemoveTimeModal);

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal--small","modalName":_vm.name},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Openingstijd verwijderen")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_vm._v("\n        Weet je zeker dat je deze openingstijd wilt verwijderen?\n        "),_c('div',{staticClass:"row",staticStyle:{"margin":"2.4rem 0"}},[_c('div',{staticClass:"col-6"},[_c('strong',[_vm._v(_vm._s(_vm.getDay(_vm.time.day)))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(_vm._s(_vm.time.open))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(_vm._s(_vm.time.close))])])])]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":_vm.confirm}},[_vm._v("Verwijderen")]),_vm._v(" "),_c('button',{staticClass:"button--alt",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Annuleer")])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddTimeModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_ModalWrapper__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vee_validate__);






var _class;








var AddTimeModal = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AddTimeModal, _Vue);

    function AddTimeModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AddTimeModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AddTimeModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AddTimeModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'add-time-modal', _this.time = {}, _this.loading = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AddTimeModal, [{
        key: 'created',
        value: function created() {
            this.$validator.attach('closingTime', [{ name: 'required' }, { name: 'regex', params: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/g }]);
        }
    }, {
        key: 'save',
        value: function save() {
            this.loading = true;

            this.validate();
        }
    }, {
        key: 'getDay',
        value: function getDay(day) {
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* getDayLong */])(day);
        }
    }, {
        key: 'getDays',
        value: function getDays() {
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* getDaysLong */])();
        }
    }, {
        key: 'beforeOpen',
        value: function beforeOpen(event) {
            var time = event.params.time;
            this.loading = false;
            this.time = !time || time === undefined ? {} : time;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _this2 = this;

            console.log('Validate', 'Start', this.$validator);


            this.$validator.validateAll().then(function (result) {
                if (result) {
                    alert('From Submitted!');

                    _this2.$emit('save', _this2.time);
                    return;
                }

                alert('Correct them errors!');
            });
        }
    }]);

    return AddTimeModal;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(AddTimeModal.name, AddTimeModal);

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal--small","modalName":_vm.name},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Openingstijd toevoegen")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"row",staticStyle:{"margin":"2.4rem 0"}},[_c('form',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Dag")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.time.day),expression:"time.day"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.time, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getDays()),function(day){return _c('option',{domProps:{"value":_vm.getDays().indexOf(day) + 1}},[_vm._v(_vm._s(day))])}))])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Openingstijd")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.time.open),expression:"time.open"}],staticClass:"form__input--text",attrs:{"type":"text","placeholder":"00:00"},domProps:{"value":(_vm.time.open)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.time, "open", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Sluittijd")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"},{name:"model",rawName:"v-model",value:(_vm.time.close),expression:"time.close"}],class:{'form__input--text': true, 'has-error': _vm.errors.has('closingTime') },attrs:{"type":"text","name":"closingTime","id":"closingTime","placeholder":"00:00"},domProps:{"value":(_vm.time.close)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.time, "close", $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('closingTime')),expression:"errors.has('closingTime')"}]},[_vm._v("ERRORRRR")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":_vm.save}},[_vm._v("Opslaan")]),_vm._v(" "),_c('button',{staticClass:"button--alt",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Annuleer")])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9 col-md-12 col-sm-12"},[_c('div',{staticClass:"block no-padding market-header"},[_c('div',{staticClass:"block--header-image"},[_c('img',{attrs:{"src":_vm.market.banner}})]),_vm._v(" "),_c('div',{staticClass:"block--content"},[_c('div',{staticClass:"row"},[_c('h4',{staticClass:"col-10"},[_vm._v(_vm._s(_vm.market.name)+", "),_c('span',[_vm._v(_vm._s(_vm.market.city))])]),_vm._v(" "),_vm._m(0,false,false)])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"block opening-times"},[_c('div',{staticClass:"block--content"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"times",staticStyle:{"flex":"1 1 auto"}},_vm._l((_vm.market.openingTimes),function(time){return _c('div',{staticClass:"time"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"0.8rem"}},[_c('div',{staticClass:"col-8 no-gutters"},[_c('strong',[_vm._v(_vm._s(_vm.getDay(time.day)))])]),_vm._v(" "),_c('div',{staticClass:"col-2 no-gutters edit",on:{"click":function($event){_vm.editTime(time)}}},[_c('i',{staticClass:"mdi mdi-pencil button--icon"})]),_vm._v(" "),_c('div',{staticClass:"col-2 no-gutters delete",on:{"click":function($event){_vm.confirmRemoveTime(time)}}},[_c('i',{staticClass:"mdi mdi-delete button--icon"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_vm._v(_vm._s(time.open))]),_vm._v(" "),_c('div',{staticClass:"col-2",staticStyle:{"text-align":"center"}},[_vm._v("tot")]),_vm._v(" "),_c('div',{staticClass:"col-5",staticStyle:{"text-align":"end"}},[_vm._v(_vm._s(time.close))])])])}))]),_vm._v(" "),_c('div',{staticClass:"buttons",staticStyle:{"width":"100%","margin-top":"2.4rem"}},[_c('button',{staticClass:"button--cta",staticStyle:{"width":"100%"},on:{"click":function($event){_vm.$modal.show('add-time-modal', { market: _vm.market })}}},[_vm._v("Toevoegen")])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-4 col-sm-12"},[_vm._v("\n            test\n        ")])]),_vm._v(" "),_c('remove-time-modal',{on:{"confirm":_vm.removeTime}}),_vm._v(" "),_c('add-time-modal',{on:{"save":_vm.createOpeningTime}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 market-header-buttons"},[_c('div',[_c('i',{staticClass:"mdi mdi-pencil button--icon"}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-favorite-outline"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Openingstijden")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VacanciesPage_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5ff59c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VacanciesPage_vue__ = __webpack_require__(547);
function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a5ff59c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VacanciesPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5ff59c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VacanciesPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VacanciesPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_empty_EmptyView__ = __webpack_require__(543);






var _class;







__webpack_require__(81);

var VacanciesPage = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(VacanciesPage, _Vue);

    function VacanciesPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, VacanciesPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = VacanciesPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(VacanciesPage)).call.apply(_ref, [this].concat(args))), _this), _this.loading = true, _this.empty = false, _this.vacancies = [], _this.markets = {}, _this.days = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag'], _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(VacanciesPage, [{
        key: 'mounted',
        value: function mounted() {
            this.fetch();
        }
    }, {
        key: 'fetch',
        value: function fetch() {
            var _this2 = this;

            console.log('[ Vacancies ]', 'Fetching vacancies...');
            this.loading = true;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore().collection('vacancies').where('visible', '==', true).get().then(function (querySnapshot) {
                if (querySnapshot.empty) {
                    console.log('[ Vacancies ]', 'No vacancies found.');
                    _this2.loading = false;
                    _this2.vacancies = [];
                } else {
                    querySnapshot.forEach(function (doc) {
                        var vacancy = doc.data();
                        vacancy.key = doc.id;

                        __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore().doc('markets/' + vacancy.marketKey).get().then(function (m) {
                            if (doc.exists) {
                                var market = m.data();

                                vacancy.name = market.name;
                                vacancy.city = market.city;

                                _this2.loading = false;
                                _this2.vacancies.push(vacancy);

                                console.log('[ Vacancies ]', 'Found vacancy', vacancy);
                            } else {
                                console.log('[ Vacancies ]', 'Market could not be found.');
                            }
                        }, function (err) {
                            console.warn('[ Vacancies ]', err);
                        });
                    });
                }
            }).catch(function (error) {
                console.log('[ Vacancies ]', "Error getting vacancies: ", error);
            });
        }
    }]);

    return VacanciesPage;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('vacancies-page', VacanciesPage);

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyView_vue__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f6c7fa2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyView_vue__ = __webpack_require__(546);
function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f6c7fa2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f6c7fa2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);





var _dec, _class;




var EmptyView = (_dec = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()({
    props: {
        title: String,
        text: String,
        image: String
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(EmptyView, _Vue);

    function EmptyView() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EmptyView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = EmptyView.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(EmptyView)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'empty-view', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return EmptyView;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('empty-view', EmptyView);

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.title}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.vacancies),function(vacancy){return (_vm.vacancies.length > 0 && !_vm.loading)?_c('md-card',{key:vacancy.key,staticClass:"col-sm-12 col-md-6"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(vacancy.title))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(vacancy.name)+", "+_vm._s(_vm.days[vacancy.day - 1]))])]),_vm._v(" "),_c('md-card-content',{domProps:{"innerHTML":_vm._s(vacancy.text)}}),_vm._v(" "),_c('md-card-actions',[_c('a',{attrs:{"href":'mailto:' + vacancy.email}},[_c('md-button',{staticClass:"md-accent"},[_vm._v("Neem contact op")])],1)])],1):_vm._e()}),_vm._v(" "),(_vm.vacancies.length <= 0 && !_vm.loading)?_c('div',[_c('empty-view',{attrs:{"title":"Geen vacatures","text":"Er zijn op dit moment geen vacatures beschikbaar. Zodra een markt vacatures toevoegt zullen deze hier getoond worden."}})],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading",staticStyle:{"margin-top":"2.4rem"}},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecruitmentPage_vue__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe8e993_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecruitmentPage_vue__ = __webpack_require__(556);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecruitmentPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe8e993_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecruitmentPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecruitmentPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modals_RemoveTimeModal_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modals_AddTimeModal_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_AddRecruitmentModal_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_EmptyView__ = __webpack_require__(553);






var _class;











__webpack_require__(81);

var RecruitmentPage = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RecruitmentPage, _Vue);

    function RecruitmentPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RecruitmentPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = RecruitmentPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RecruitmentPage)).call.apply(_ref, [this].concat(args))), _this), _this.vacancies = [], _this.loading = true, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RecruitmentPage, [{
        key: 'mounted',
        value: function mounted() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().onAuthStateChanged(function (user) {
                if (user) {
                    _this2.fetchMarket();
                } else {
                    console.log(App.name, 'User is signed out');
                    _this2.$router.push('/auth');
                }
            });
        }
    }, {
        key: 'fetchMarket',
        value: function fetchMarket() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore().collection('markets').doc(this.$route.params.key).get().then(function (snap) {
                console.log('Stand!', snap.data());

                _this3.loading = false;
                _this3.market = snap.data();
            }).catch(function (error) {
                console.error('Error', error);
                _this3.loading = false;
            });
        }
    }]);

    return RecruitmentPage;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('recruitment-page', RecruitmentPage);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddRecruitmentModal_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b17833_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddRecruitmentModal_vue__ = __webpack_require__(552);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddRecruitmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b17833_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddRecruitmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddRecruitmentModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_ModalWrapper__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vee_validate__);






var _class;








var AddRecruitmentModal = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AddRecruitmentModal, _Vue);

    function AddRecruitmentModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AddRecruitmentModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AddRecruitmentModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AddRecruitmentModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'add-recruitment-modal', _this.time = {}, _this.loading = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AddRecruitmentModal, [{
        key: 'created',
        value: function created() {}
    }, {
        key: 'save',
        value: function save() {
            this.loading = true;

            this.validate();
        }
    }, {
        key: 'getDay',
        value: function getDay(day) {
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* getDayLong */])(day);
        }
    }, {
        key: 'getDays',
        value: function getDays() {
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* getDaysLong */])();
        }
    }, {
        key: 'beforeOpen',
        value: function beforeOpen(event) {
            var time = event.params.time;
            this.loading = false;
            this.time = !time || time === undefined ? {} : time;
        }
    }, {
        key: 'validate',
        value: function validate() {}
    }]);

    return AddRecruitmentModal;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(AddRecruitmentModal.name, AddRecruitmentModal);

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal","modalName":_vm.name},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Vacature opstellen")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Branch")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.time.day),expression:"time.day"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.time, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getDays()),function(day){return _c('option',{domProps:{"value":_vm.getDays().indexOf(day) + 1}},[_vm._v(_vm._s(day))])}))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Dag")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.time.day),expression:"time.day"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.time, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getDays()),function(day){return _c('option',{domProps:{"value":_vm.getDays().indexOf(day) + 1}},[_vm._v(_vm._s(day))])}))])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Omschrijving")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea has-error",attrs:{"placeholder":"Start typing here..."}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Contact e-mail:")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"email","name":"email"}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":_vm.save}},[_vm._v("Opslaan")]),_vm._v(" "),_c('button',{staticClass:"button--alt",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Annuleer")])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner",staticStyle:{"top":"40%"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyView_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b142662_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyView_vue__ = __webpack_require__(555);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b142662_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);






var _dec, _class;




var EmptyView = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
    props: {
        title: String,
        message: String,
        actionText: String
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(EmptyView, _Vue);

    function EmptyView() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EmptyView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = EmptyView.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(EmptyView)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'empty-view', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EmptyView, [{
        key: 'action',
        value: function action() {
            this.$emit('action');
        }
    }]);

    return EmptyView;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component(EmptyView.name, EmptyView);

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"block--small empty-content"},[_c('h2',{staticClass:"empty-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('button',{staticClass:"button--link",on:{"click":_vm.action}},[_vm._v(_vm._s(_vm.actionText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vacancies.length == 0)?_c('empty-view',{attrs:{"title":"Geen vacatures","message":"Er zijn geen openstaande vacatures beschikbaar. Vacatures worden op de pagina van de markt getoond en zijn deelbaar via social media.","actionText":"Stel een vacature op"},on:{"action":function($event){_vm.$modal.show('add-recruitment-modal');}}}):_vm._e(),_vm._v(" "),_c('add-recruitment-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d16dead2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(560);
function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d16dead2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrivacyPolicy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_TheHeader__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_TheFooter__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_Sidebar__ = __webpack_require__(80);





var _class;







var PrivacyPolicy = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PrivacyPolicy, _Vue);

    function PrivacyPolicy() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PrivacyPolicy);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PrivacyPolicy.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PrivacyPolicy)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'privacy-policy', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return PrivacyPolicy;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(PrivacyPolicy.name, PrivacyPolicy);

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small text"},[_c('h3',[_vm._v("Privacy voorwaarden")]),_vm._v(" "),_c('p',[_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet cum cumque ipsum iusto magni nemo nesciunt odit quaerat quibusdam quod, saepe suscipit tempora tenetur unde voluptas. Consequatur dolore ducimus facere!\n        ")]),_c('h4',[_vm._v("Dit is een tussenkop")]),_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium corporis excepturi possimus sunt. Consectetur dolore dolorum enim et facilis non, odio pariatur qui similique voluptatibus. Cupiditate ipsum numquam vitae voluptates.\n        "),_c('br'),_c('br'),_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam esse explicabo nobis pariatur qui quia tempora vitae voluptate. Laudantium provident vero voluptas? Accusamus dolorem inventore libero quasi qui, voluptate.\n        "),_c('h4',[_vm._v("Dit is een tussenkop")]),_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A accusamus dolor, dolorum eveniet, ex excepturi facilis illum impedit libero molestiae nobis nulla officia omnis praesentium quos rem sapiente, velit voluptatem.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfService_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd1985f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfService_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd1985f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfService_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd1985f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfService_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsOfService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_TheHeader__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_TheFooter__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_Sidebar__ = __webpack_require__(80);





var _class;







var TermsOfService = __WEBPACK_IMPORTED_MODULE_5_vue_class_component___default()(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TermsOfService, _Vue);

    function TermsOfService() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TermsOfService);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TermsOfService.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TermsOfService)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'terms-of-service', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return TermsOfService;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(TermsOfService.name, TermsOfService);

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small text"},[_c('h3',[_vm._v("Gebruiksvoorwaarden")]),_vm._v(" "),_c('p',[_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet cum cumque ipsum iusto magni nemo nesciunt odit quaerat quibusdam quod, saepe suscipit tempora tenetur unde voluptas. Consequatur dolore ducimus facere!\n        ")]),_c('h4',[_vm._v("Dit is een tussenkop")]),_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium corporis excepturi possimus sunt. Consectetur dolore dolorum enim et facilis non, odio pariatur qui similique voluptatibus. Cupiditate ipsum numquam vitae voluptates.\n        "),_c('br'),_c('br'),_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam esse explicabo nobis pariatur qui quia tempora vitae voluptate. Laudantium provident vero voluptas? Accusamus dolorem inventore libero quasi qui, voluptate.\n        "),_c('h4',[_vm._v("Dit is een tussenkop")]),_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A accusamus dolor, dolorum eveniet, ex excepturi facilis illum impedit libero molestiae nobis nulla officia omnis praesentium quos rem sapiente, velit voluptatem.\n        "),_c('br'),_c('br'),_vm._v(" "),_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_General_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c56ee24_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_General_vue__ = __webpack_require__(568);
function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c56ee24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_General_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c56ee24_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_General_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return General; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);






var _dec, _class;







var General = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(General, _Vue);

    function General() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, General);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = General.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(General)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'general-menu', _this.showMobileMenu = true, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(General, [{
        key: 'logout',
        value: function logout() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signOut().then(function () {
                _this2.$router.go({ name: 'signin' });
            });
        }
    }, {
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {}
    }]);

    return General;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('general-menu', General);

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"menu__item divider--before"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'markets' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-chevron-right"}),_vm._v(" "),_c('span',[_vm._v("Markets")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item divider--before"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'settings' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-settings"}),_vm._v(" "),_c('span',[_vm._v("Instellingen")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item"},[_c('div',{staticClass:"menu__link",on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_vm._v("Log out")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c0374d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__(572);
function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c0374d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c0374d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Logo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);






var _dec, _class;







var Logo = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Logo, _Vue);

    function Logo() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Logo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Logo.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Logo)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'logo-menu', _this.showMobileMenu = true, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Logo, [{
        key: 'logout',
        value: function logout() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signOut().then(function () {
                _this2.$router.go({ name: 'signin' });
            });
        }
    }, {
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {}
    }]);

    return Logo;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('logo-menu', Logo);

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"logo",attrs:{"src":"/static/images/logo.svg","alt":"Mijn Markt Logo"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Market_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9f25b5a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Market_vue__ = __webpack_require__(576);
function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9f25b5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Market_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9f25b5a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Market_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarketMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);






var _dec, _class;







var MarketMenu = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MarketMenu, _Vue);

    function MarketMenu() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MarketMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = MarketMenu.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MarketMenu)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'market-menu', _this.showMobileMenu = true, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MarketMenu, [{
        key: 'logout',
        value: function logout() {}
    }, {
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {}
    }]);

    return MarketMenu;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('market-menu', MarketMenu);

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"menu__item"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'markets' }}},[_c('i',{staticClass:"mdi mdi-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("Back")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item divider--before"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'market-dashboard' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-chevron-right"}),_vm._v(" "),_c('span',[_vm._v("Dashboard")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'market-stands' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-settings"}),_vm._v(" "),_c('span',[_vm._v("Ondernemers")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'market-requests' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-settings"}),_vm._v(" "),_c('span',[_vm._v("Aanvragen")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'market-recruitment' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-settings"}),_vm._v(" "),_c('span',[_vm._v("Werving")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'market-notes' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-settings"}),_vm._v(" "),_c('span',[_vm._v("Notities")])])],1),_vm._v(" "),_c('li',{staticClass:"menu__item divider--before"},[_c('router-link',{staticClass:"menu__link",attrs:{"to":{ name: 'market-users' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_c('i',{staticClass:"breadcrumb__icon mdi mdi-settings"}),_vm._v(" "),_c('span',[_vm._v("Gebruikers")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c53e46c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__ = __webpack_require__(433);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c53e46c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d16120_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__ = __webpack_require__(435);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d16120_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWrapper_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f8b990_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWrapper_vue__ = __webpack_require__(456);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f8b990_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc75e020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(443);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc75e020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ })

},[309]);


// WEBPACK FOOTER //
// static/js/app.ffddae580886a680d4bc.js